var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.24H1V11H3.5M4 7.24L14 1L24 7.24M4 7.24H24M24 7.24H27V11H24.5M3.5 22.6994H1V25.0994H27V22.6994H24.5M3.5 22.6994V11M3.5 22.6994H6.5M3.5 11H6.5M6.5 11V22.6994M6.5 11H9.5M6.5 22.6994H9.5M9.5 11V22.6994M9.5 11H18.5M9.5 22.6994H12.5H15.5H18.5M18.5 22.6994V11M18.5 22.6994H21.5M18.5 11H21.5M21.5 11V22.6994M21.5 11H24.5M21.5 22.6994H24.5M24.5 22.6994V11",
    stroke: "#272638",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitution);
export default __webpack_public_path__ + "static/media/institution.0e5127da5927a9206f729d7aee0721ee.svg";
export { ForwardRef as ReactComponent };